const MenuList = [
    {
        id: 1,
        title: "JUNIOR",
        simplePrice: "$4500",
        completePrice: "",
    },
    {
        id: 2,
        title: "CLÁSICA",
        simplePrice: "$5000",
        completePrice: "$6000",
    },
    {
        id: 3,
        title: "CLÁSICA DOBLE",
        simplePrice: "$7000",
        completePrice: "$8000",
    },
    {
        id: 4,
        title: "CLÁSICA TRIPLE",
        simplePrice: "$9000",
        completePrice: "$10000",
    },
    {
        id: 5,
        title: "BURGER POLLO",
        simplePrice: "$5000",
        completePrice: "$6000",
    },
    {
        id: 6,
        title: "BURGER POLLO DOBLE",
        simplePrice: "$7000",
        completePrice: "$8000",
    },
    {
        id: 7,
        title: "BURGER POLLO TRIPLE",
        simplePrice: "$9000",
        completePrice: "$10000",
    },
    {
        id: 8,
        title: "MEGA",
        simplePrice: "$6500",
        completePrice: "$7500",
    },
    {
        id: 9,
        title: "MEGA DOBLE",
        simplePrice: "$8500",
        completePrice: "$9500",
    },
    {
        id: 10,
        title: "MEGA TRIPLE",
        simplePrice: "$10500",
        completePrice: "$11500",
    },
    {
        id: 11,
        title: "GOURMET",
        simplePrice: "$7000",
        completePrice: "$8000",
    },
    {
        id: 12,
        title: "GOURMET DOBLE",
        simplePrice: "$9000",
        completePrice: "$10000",
    },
    {
        id: 13,
        title: "GOURMET TRIPLE",
        simplePrice: "$11000",
        completePrice: "$12000",
    },
    {
        id: 14,
        title: "SMASH",
        simplePrice: "$8000",
        completePrice: "$9000",
    },
    {
        id: 15,
        title: "SMASH DOBLE",
        simplePrice: "$10000",
        completePrice: "$11000",
    },
    {
        id: 16,
        title: "SMASH TRIPLE",
        simplePrice: "$12000",
        completePrice: "$13000",
    },
    {
        id: 17,
        title: "LOMITO",
        simplePrice: "$9000",
        completePrice: "$10000",
    },
    {
        id: 18,
        title: "NUGGET'S DE POLLO",
        simplePrice: "$7500",
        completePrice: "",
    },
    {
        id: 19,
        title: "PAPAS TRADICIONALES",
        simplePrice: "$4500",
        completePrice: "",
    },
    {
        id: 20,
        title: "PAPAS GOURMET",
        simplePrice: "$5000",
        completePrice: "",
    },
    {
        id: 23,
        title: "PAPAS CON CHEDDAR",
        simplePrice: "$8000",
        completePrice: "",
    },
    {
        id: 24,
        title: "SALAD",
        simplePrice: "$7500",
        completePrice: "",
    },
];

export default MenuList;